import InfoLabel from "./InfoLabel";
import classes from "../../styles/InfoLabel.module.css";
import { useAppSelector, useTexts, useConfig } from "../../hooks";
import { doTranslation, numberToReadableStr } from "../../utils";
import { Fragment } from "react";

const Separator: React.FC<{ visible: boolean }> = ({ visible }) => {
  if (!visible) return null;
  return <span className={classes.separator}>|</span>;
};

const ExtraInfo: React.FC<{ visible: boolean }> = ({ visible }) => {
  const details = useAppSelector((state) => state.details);
  const { maxWin } = useConfig();
  const { common, custom } = useTexts();

  if (!visible || !maxWin) return <div></div>;

  const maxWinData = details.extraInfo.maxWin
    ? [
        doTranslation("maxwin", {}, common),
        `x${maxWin.value} (1:${numberToReadableStr(maxWin.chance, common)})`,
      ]
    : null;

  const rtpData = details.extraInfo.rtp
    ? ["RTP:", `${details.rtp.value || "N/A"}%`]
    : null;

  const versionData = details.extraInfo.version
    ? [
        `${doTranslation("version", {}, common)}:`,
        custom.gameversion || "1.0.0",
      ]
    : null;

  const data = [maxWinData, rtpData, versionData].filter((d) => d);

  return (
    <InfoLabel shape="rectangle" className={classes.engine} direction="left">
      {data.map((d, i) => {
        if (!d) return null;
        return (
          <Fragment>
            <span className={classes.key}>{d[0]}</span>
            <span className={classes.value}>{d[1]}</span>
            <Separator visible={i < data.length - 1} />
          </Fragment>
        );
      })}
    </InfoLabel>
  );
};

export default ExtraInfo;
